<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false && !!token"
  >
    @if (!!token) {
    <div class="sidenav-profile">
      <div class="sidenav-avatar-wrap">
        @if (profilePic) {
        <img class="sidenav-avatar" fhImageUrl [originalUrl]="profilePic" alt="Profile picture" />
        } @else {
        <mat-icon class="sidenav-avatar-fallback">account_circle</mat-icon>
        }
      </div>
      <span class="sidenav-username">{{ username }}</span>
    </div>

    <mat-nav-list class="sidenav-menu">
      @for (menuItem of menuItems; track menuItem) {
      <a
        mat-list-item
        class="nav-link"
        [routerLinkActive]="'active'"
        [routerLink]="[menuItem.path]"
      >
        @if (menuItem.image) {
          <img [src]="menuItem.image" class="nav-icon-img" alt="" />
        } @else {
          <mat-icon>{{ menuItem.icon }}</mat-icon>
        }
        <span>{{ menuItem.title }}</span>
        @if (dotCount(menuItem.badge); as n) {
          <span class="nav-badge" [attr.aria-label]="n + ' new'">{{ n > 99 ? '99+' : n }}</span>
        }
      </a>
      }
    </mat-nav-list>

    <button type="button" class="sidenav-logout" (click)="logout()">
      <mat-icon>settings_power</mat-icon>
      <span>Logout</span>
    </button>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    @if (isHandset$ | async) {
    <div class="mobile-toggle-bar">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
      >
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
    </div>
    }
    <ng-content></ng-content>
  </mat-sidenav-content>
</mat-sidenav-container>
